import { Directive, HostListener, ElementRef, Renderer2 } from '@angular/core';
import { AuthenticationService } from '../../_services/authenticationService';

@Directive({
  selector: '[appActionButton]'
})
export class AppActionButton {

  constructor(el: ElementRef, authenticationService: AuthenticationService, renderer2: Renderer2) {
      const userData = authenticationService.currentUserValue;
      if (userData && userData.roleData && userData.roleData.readOnly) {
        setTimeout(() => {
          el.nativeElement.remove();
        });
      }
  }
}
